import { ref } from 'vue'

export const useRange = (props, emit) => {
  const CUSTOM_RANGE = 'RANGE'
  const selected =
    props.start || props.end
      ? ref(CUSTOM_RANGE)
      : props.modelValue
        ? ref(props.modelValue)
        : ref(null)
  const validRange = ref(true)
  const startValue = props.start
    ? ref(props.start)
    : ref<Date | number | null>(null)
  const endValue = props.end ? ref(props.end) : ref<Date | number | null>(null)
  const startValueTemp = ref<Date | number | null>(null)
  const endValueTemp = ref<Date | number | null>(null)
  const labelValue = ref(props.labelTop)
  const modal = ref(false)
  const validationMessage = ref('')

  function onCancel() {
    if (startValue.value === null || endValue.value === null) {
      selected.value = null
      triggerSelectionEvent(selected.value)
    }
    startValue.value = startValueTemp.value
    endValue.value = endValueTemp.value
    modal.value = false
  }

  function updateSelection() {
    if (selected.value === CUSTOM_RANGE) {
      startValueTemp.value = startValue.value
      endValueTemp.value = endValue.value
      modal.value = true
    } else {
      startValue.value = null
      endValue.value = null
    }

    triggerSelectionEvent(selected.value)
  }

  function triggerSelectionEvent(value: Date | number | string | null) {
    emit(
      'update-selection',
      value,
      props.options.find((option) => option.value === value),
    )
  }

  function updateRange() {
    const start = startValue.value
    const end = endValue.value
    validationMessage.value = ''

    if (start === null && end === null) {
      validationMessage.value = 'At least one of the values must be entered'
      return
    }

    if (start !== null && end !== null && start > end) {
      validationMessage.value = 'Start range should be less than end value'
      return
    }

    emit('update-range', startValue.value, endValue.value)
    modal.value = false
  }

  return {
    CUSTOM_RANGE,
    selected,
    modal,
    updateSelection,
    updateRange,
    startValue,
    endValue,
    labelValue,
    validRange,
    validationMessage,
    onCancel,
  }
}
